<template>
  <div style="width:1190px; margin: 0 auto">
    <div class="integralBreadcrumb">
      <div class="integralBreadcrumb-item">
        <span>S2B平台在线交易标准合同模板-款到发货版</span>
      </div>
    </div>
    <div class="home">
      <p style="line-height:150%"><span style="position:relative;z-index:251657728"> </span></p>
      <p style="display:inline;"><a><strong><span style="font-size:24px;line-height:150%">宁东工业超市</span></strong></a><strong><span style="font-size:24px;line-height:150%;font-family:宋体">平台在线销售合同</span></strong></p>
      <table cellpadding="0"
             cellspacing="0"
             style="display:inline;">
        <tbody>
          <tr class="firstRow">
            <td width="340"
                height="26"
                bgcolor="white"
                style="vertical-align:top;background:white"><span> &nbsp; 合同编号：SCJSD202&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; －&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
          </tr>
          <tr class="firstRow">
            <td width="340"
                height="56"
                bgcolor="white"
                style="vertical-align:top;background:white"><span>&nbsp; 签订日期：&nbsp; </span>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <br />
      <p style="line-height:150%">
        <strong><span style=";line-height:150%;font-family:宋体">买方：{{ dataJson ? dataJson.companyName : '' }}</span></strong>
      </p>
      <p style="line-height:150%">
        <strong><span style=";line-height:150%;font-family: 宋体">卖方：浙江工自仪网络有限公司</span></strong>
      </p>
      <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">经买卖双方协商一致，签订本购销合同。</span></p>
      <p style="line-height:150%;text-autospace:none;vertical-align:bottom"><span style=";line-height:150%;font-family:宋体">一、</span><span style=";line-height:150%;font-family:宋体">货物清单如下：</span></p>
      <table cellspacing="0"
             cellpadding="0"
             width="100%">
        <tbody>
          <tr style=";height:18px"
              class="firstRow">
            <td width="32"
                rowspan="2"
                style="border: 1px solid windowtext; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">序号</span></p>
            </td>
            <td width="72"
                rowspan="2"
                style="border-top: 1px solid windowtext; border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-image: initial; border-left: none; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">商品名称</span></p>
            </td>
            <td width="46"
                rowspan="2"
                style="border-top: 1px solid windowtext; border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-image: initial; border-left: none; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">品牌</span></p>
            </td>
            <td width="61"
                rowspan="2"
                style="border-top: 1px solid windowtext; border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-image: initial; border-left: none; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">规格型号</span></p>
            </td>
            <td width="46"
                rowspan="2"
                style="border-top: 1px solid windowtext; border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-image: initial; border-left: none; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">数量</span></p>
            </td>
            <td width="133"
                colspan="2"
                style="border-top: 1px solid windowtext; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid black; padding: 0px;"
                height="18">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">价格</span></p>
            </td>
            <td width="261"
                colspan="4"
                style="border-top: 1px solid windowtext; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid black; padding: 0px;"
                height="18"
                v-if="discountFlag">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">促销折后价</span></p>
            </td>
          </tr>
          <tr style=";height:11px">
            <td width="57"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px;"
                height="11">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">单价</span></p>
            </td>
            <td width="76"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid black; padding: 0px;"
                height="11">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">总价</span></p>
            </td>
            <td width="75"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px;"
                height="11"
                v-if="discountFlag">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">折扣率</span></p>
            </td>
            <td width="83"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px;"
                height="11"
                v-if="discountFlag">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">单价</span></p>
            </td>
            <td width="103"
                colspan="2"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid black; padding: 0px;"
                height="11"
                v-if="discountFlag">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:宋体">总价</span></p>
            </td>
          </tr>
          <tr style=";height:28px"
              v-for="(item, index) in dataJson ? dataJson.payOrderItemVoList : []"
              :key="index">
            <td width="32"
                style="border-right: 1px solid black; border-bottom: 1px solid black; border-left: 1px solid black; border-image: initial; border-top: none; padding: 0px;"
                height="28">
              <p style="text-align:center;line-height:150%"><span style=";line-height:150%;font-family:   宋体">{{index + 1}}</span></p>
            </td>
            <td width="72"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px;"
                height="28">{{item.goodsName}}</td>
            <td width="46"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px;"
                height="28">{{item.brandName}}</td>
            <td width="61"
                style="text-align: left; word-wrap: break-word; word-break: break-all; border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px 5px;"
                height="28">{{item.goodsModel}}</td>
            <td width="46"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px;"
                height="28">{{item.goodsNum}}</td>
            <td width="57"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid windowtext; padding: 0px;"
                height="28">{{item.goodsPrice}}</td>
            <td width="76"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px;"
                height="28">{{item.money}}</td>
            <td width="75"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid windowtext; padding: 0px;"
                height="28"
                v-if="discountFlag">{{item.discount}}%</td>
            <td width="83"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid windowtext; padding: 0px;"
                height="28"
                v-if="discountFlag">{{item.goodsPriceDiscount}}</td>
            <td width="103"
                style="text-align: center;border-top: none; border-left: none; border-bottom: 1px solid black; border-right: 1px solid black; padding: 0px;"
                height="28"
                v-if="discountFlag">{{item.goodsMoney}}</td>
          </tr>
          <tr style=";page-break-inside:avoid;height:28px">
            <td width="652"
                colspan="11"
                style="border-top: none; border-left: 1px solid black; border-bottom: 1px solid windowtext; border-right: 1px solid black; padding: 0px;"
                height="28">
              <p style="text-align:center;line-height:150%"><strong><span style=";line-height:150%;font-family:宋体">合计人民币金额（大写）：&nbsp;{{ payMoneyBig }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></strong><span style=";line-height:   150%;font-family:宋体">（￥ &nbsp;{{ dataJson ? dataJson.payMoney : '' }}&nbsp; 元整</span><span style=";line-height:150%;font-family:宋体">（人民币）</span><span style=";line-height:150%;font-family:宋体">）</span></p>
              <p style="text-align:left;text-indent:28px;line-height:150%"><a><span style=";line-height:150%;font-family:宋体">（本报价不含工程服务费）</span></a></p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="margin-left:0;text-indent:0;line-height:36px;text-autospace:none;vertical-align:bottom"><span style=";font-family:宋体">二、<span style="font:9px &#39;Times New Roman&#39;">&nbsp; </span></span><span style=";font-family:宋体">产品的型号、规格、技术标准与参数、包装、质量相关事项、售后服务等等均以产品原生产企业或其指定生产企业的企业标准为准。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">三、</span><span style=";font-family:宋体">在买方提交订单五日内（且不晚于本合同第四条约定的卖方发运日期的五日前），买方应向卖方支付全部合同款。因买方原因迟延支付上述合同款的，卖方发运时间相应顺延。</span></p>
      <!-- <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体">卖方收款账号信息：</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体">电汇收款账号：</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体">户名：中控技术股份有限公司</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">账号：1202021419900065818</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">开户行：中国工商银行杭州钱江支行</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">电子票据收款账号：</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">户名：中控技术股份有限公司</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">账号：331065970018010000163</span></p>
      <p style="text-indent:28px;line-height:36px"><span style=";font-family:宋体;">开户行：交通银行杭州城站支行</span><span style=";line-height:150%;font-family:宋体"> &nbsp;</span></p> -->
      <p style="line-height:150%">
        <span style=";line-height:150%;font-family:宋体">四、</span>
        <!-- <span style=";line-height:150%;font-family:宋体">发运时间暂定为:
          <span style="text-decoration:underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          年<span style="text-decoration:underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          月<span style="text-decoration:underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>日
        </span>&nbsp; -->
        <span style=";line-height:150%;font-family:宋体">本合同货物的发运时间由买卖双方协商确定。</span></p>
      <p style="line-height: 36px">
        <a>
          <span style=";font-family:宋体">五、</span>
          <span style=";font-family:宋体">本合同货物</span>
        </a>&nbsp;
        <span style=";font-family:宋体">收货人为：</span>
        <span style="text-decoration:underline;">&nbsp;{{ addressInfo.receiveGoodsPerson }}&nbsp;</span>
        <strong><em><span style=";font-family:宋体">；</span></em></strong>
        <span style=";font-family:宋体">货物运达地址</span>
        <span style=";font-family:宋体">为：
          <span style="text-decoration:underline;">&nbsp;{{ addressInfo.province + addressInfo.city + addressInfo.area + addressInfo.address }}&nbsp;</span>
          ；联系电话：<span style="text-decoration:underline;">&nbsp;{{ addressInfo.receiveGoodsPhone }}&nbsp;</span>。
        </span>
        <span style=";font-family:宋体">卖方向上述地址运输的货物，经签收后视为买方已经收到货物。如果买方需要变更上述信息的，须在卖方发运前</span>7<span style=";font-family:宋体">个工作日之前告知卖方，否则全部损失由买方自行承担。因买方提供的收货信息不准确、不完整，卖方不承担迟延送货的责任。如因买方填写收货信息错误导致卖方将货物发送到错误的地址，由此造成的损失由买方负责。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">六、</span> <span style=";font-family:宋体">由卖方办理运输（或邮寄）手续，包装运输费用由<a><span style="text-decoration:underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></a></span>&nbsp;<span style=";font-family:宋体">承担；</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">七、</span><span style=";font-family:宋体">买方应在货物到达货物运达地址之日进行验收，如有问题三天内以书面形式向卖方提出，否则视为验收通过。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">八、</span><span style=";font-family:宋体">在卖方未收到全额货款之前，本合同未支付货款部分的商品所有权仍为卖方所有。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">九、</span><span style=";font-family:宋体">发票：</span></p>
      <p style="line-height:36px"><span style=";font-family:宋体">1．卖方向买方开具合法有效发票。如需开具增值税专用发票，买方向卖方提供开票信息且经卖方审核开票信息通过后，在订单收货完成后，卖方可向买方开具增值税专用发票。如买方需开具增值税普通发票，在订单收货完成后，卖方可以提供电子发票；</span></p>
      <p style="line-height:36px"><span style=";font-family:宋体">2．卖方开具纸质发票后将发票快递至买方指定地点，买方收取发票，如超期7日未收到发票，应与卖方确认发票送达情况，超过7日未核实，视为买方已确认收到发票。如发票开具与买方需求不符，买方应在签收发票后７日内向卖方反馈核实，卖方收取买方退还发票后积极配合更换发票并送达买方。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">十、<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp; </span></span><span style=";font-family:宋体">任何一方违反本合同约定的，另一方追究其违约责任所支出的费用（包括但不限于律师费、交通费、诉讼费、调查费等）由违约方承担。</span></p>
      <p style="line-height: 36px"><span style=";font-family:宋体">十一、<span style="font:9px &#39;Times New Roman&#39;">&nbsp;&nbsp; </span></span><span style=";font-family:宋体">本合同盖章后生效，生效后任何一方若<span style="letter-spacing:-0">需要变更或解除合同，应由双方书面共同确认。</span>本合同一式肆份，供、需双方各执贰份，具有同等法律效力。</span></p>
      <table cellspacing="0"
             cellpadding="0"
             width="100%">
        <tbody>
          <tr style=";page-break-inside:avoid;height:19px"
              class="firstRow">
            <td width="322"
                style="border: 1px solid windowtext; padding: 0px 7px;"
                height="19">
              <p style="text-align:center;line-height:150%"><strong><span style=";line-height:150%;font-family:宋体">买</span></strong><strong><span style=";line-height:150%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></strong><strong><span style=";line-height:150%;font-family:   宋体">方</span></strong></p>
            </td>
            <td width="340"
                style="border-top: 1px solid windowtext; border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-image: initial; border-left: none; padding: 0px 7px;"
                height="19">
              <p style="text-align:center;line-height:150%"><strong><span style=";line-height:150%;font-family:宋体">卖</span></strong><strong><span style=";line-height:150%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></strong><strong><span style=";line-height:150%;font-family:   宋体">方</span></strong></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:20px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="20">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">单位名称（章）{{ dataJson ? dataJson.companyName : ''}}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="20">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">单位名称（章）浙江工自仪网络有限公司</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">单位地址：</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">单位地址：浙江省杭州市滨江区浦沿街道六和路</span><span style=";line-height:150%">309</span><span style=";line-height:150%;font-family:宋体">号B 区B213</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%">
                <span style=";line-height:150%;font-family:宋体">电</span>
                <span style=";line-height:150%">&nbsp;&nbsp;&nbsp; </span>
                <span style=";line-height:150%;font-family:宋体">话：</span>
                <span style=";line-height:150%">{{ userInfo.mobile }}</span>
                <!-- || (dataJson && dataJson.contactPhone) -->
              </p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%">
                <span style=";line-height:150%;font-family:宋体">电</span>
                <span style=";line-height:150%">&nbsp; &nbsp;&nbsp;</span>
                <span style=";line-height:150%;font-family:宋体">话：</span>
                <span style=";line-height:150%">{{ dataJson && dataJson.contactPhone ? dataJson.contactPhone+' 、': '' }}0571-88851888</span>
              </p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">法定代表人：</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">法定代表人：郭飚</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:16px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="16">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">委托代理人：{{ dataJson?dataJson.userName: '' }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="16">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">委托代理人：{{ dataJson?dataJson.contactName: '' }}</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:6px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="6">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">签约日期：</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">年</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">月</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">日</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="6">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">签约日期：</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">年</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">月</span><span style=";line-height:150%">&nbsp;&nbsp;&nbsp; </span><span style=";line-height:150%;font-family:宋体">日</span></p>
            </td>
          </tr>
          <!-- <tr style=";page-break-inside:avoid;height:19px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="19">
              <p style="text-align:center;line-height:150%"><strong><span style=";line-height:150%;font-family:宋体">开票信息</span></strong></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="19">
              <p style="text-align:center;line-height:150%"><strong><span style=";line-height:150%;font-family:宋体">开票信息</span></strong></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:14px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="14">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【公司名称】：{{ invoiceInfo.companyName }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="14">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【公司名称】中控技术股份有限公司</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:25px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="25">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【纳税人识别号】：{{ invoiceInfo.taxpayerIdentity }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="25">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【纳税人识别号】</span><span style=";line-height:150%">91330000720082446H</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【地址、电话】：{{ invoiceInfo.companyAddress + invoiceInfo.companyPhone }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【地址、电话】杭州市滨江区六和路</span><span style=";line-height:150%">309</span><span style=";line-height:150%;font-family:宋体">号</span><span style=";line-height:150%"> 0571-88851888</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【开户行】{{ invoiceInfo.openingBank }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【开户行】工商银行杭州市分行钱江支行</span></p>
            </td>
          </tr>
          <tr style=";page-break-inside:avoid;height:17px">
            <td width="322"
                style="border-right: 1px solid windowtext; border-bottom: 1px solid windowtext; border-left: 1px solid windowtext; border-image: initial; border-top: none; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【帐号】{{ invoiceInfo.bankAccountNo }}</span></p>
            </td>
            <td width="340"
                style="border-top: none; border-left: none; border-bottom: 1px solid windowtext; border-right: 1px solid windowtext; padding: 0px 7px;"
                height="17">
              <p style="line-height:150%"><span style=";line-height:150%;font-family:宋体">【帐号】</span><span style=";line-height:150%">1202021419900065818</span></p>
            </td>
          </tr> -->
        </tbody>
      </table>
      <p><br /></p>
      <p><br /><br /><br /></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderContract',
  data () {
    return {
      // 生成订单参数
      params: {
        orderSource: '',
        shoppingCart: {},
        shoppingCartFormList: [],
        companyId: '',
        companyName: '',
        addressId: '',
        userId: ''
      },
      dataJson: null,
      discountFlag: false,
      userName: '',
      payType: '',
      payMoney: '',
      discountAmount: '',
      companyName: '',
      contactName: '', // 客户负责人
      contactPhone: '',
      goodsTableData: [], // 订单
      invoiceInfo: {
        companyName: '',
        taxpayerIdentity: '',
        companyAddress: '',
        companyPhone: '',
        openingBank: '',
        bankAccountNo: ''
      }, // 发票
      addressInfo: {
        receiveGoodsPerson: '',
        receiveGoodsPhone: '',
        province: '',
        city: '',
        area: '',
        address: ''
      }, // 收货地址
      userInfo: {
        customerName: '',
        mobile: '',
        name: ''
      } // 用户信息
    }
  },
  computed: {
    payMoneyBig: function () {
      var n = this.dataJson ? this.dataJson.payMoney : 0
      var fraction = ['角', '分']
      var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
      ]
      var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
      ]
      var head = n < 0 ? '欠' : ''
      n = Math.abs(n)
      var s = ''
      for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(Math.round(n * 100) / 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
        // console.log(n, '-__________---', Math.round(n * 100) / 10, '---=====+-', Math.pow(10, i), '----===', Math.round(n * 100) / 10 * Math.pow(10, i))
        // console.log(s, '---s', Math.floor(n * 10 * Math.pow(10, i)) % 10, '-----', Math.floor(n * 10 * Math.pow(10, i)), '====', n * 10 * Math.pow(10, i))
      }
      s = s || '整'
      n = Math.floor(n)
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        var p = ''
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p
          n = Math.floor(n / 10)
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
      }
      return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整')
    }
  },
  methods: {
    getInvoiceInfo () {
      let currentRow = this.$route.query.currentRow
      if (currentRow && currentRow !== '') {
        this.$request.get(`/pay/invoiceinfo/info/${currentRow}`).then((data) => {
          this.invoiceInfo = data
        })
      }
    },
    getAddressInfo () {
      let addressId = this.$route.query.addressId
      if (addressId && addressId !== '') {
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/integral/userorderaddress/info/${addressId}`).then(data => {
          console.warn(data)
          this.addressInfo = data.result.info
        })
      }
    },
    getUserInfo () {
      this.$request.get(`/front/consumer/user/queryUserInfo`)
        .then((res) => {
          this.userInfo = res
        }).catch(() => { })
    },
    getOrder () {
      this.$http.post(`/front/consumer/order/generateOrder`, this.params)
        .then(({ data: res }) => {
          // console.log(res)
          if (res.code !== 0) {
            return false
          }
          let data = res.data
          this.dataJson = data
          this.discountFlag = data.promotion !== 1
          this.params.companyId = data.companyId
          this.params.companyName = data.companyName
          this.params.userId = data.userId
          if (data.sysUserAddressVos && data.sysUserAddressVos.length) {
            let address = data.sysUserAddressVos.find(item => {
              return item.userAddressId === this.params.addressId
            })
            if (address) {
              this.addressInfo = address
            }
          }
          let invoiceInfoList = this.dataJson.payInvoiceInfoVoList || []
          let invoiceInfo = invoiceInfoList.find(item => {
            // console.log(item.invoiceId, this.$route.query.invoiceId, item)
            return item.invoiceId === this.$route.query.invoiceId
          })
          if (invoiceInfo) {
            this.invoiceInfo = invoiceInfo
          }
          // // this.goodsTableData = data.payOrderItemVoList
          // if (data.payOrderItemVoList && data.payOrderItemVoList.length) {
          //   this.distributionFlag = data.payOrderItemVoList.every(item => {
          //     // distribution  =2支持  =1 不支持 3面议
          //     return item.distribution !== 1
          //   })
          // } else {
          //   this.distributionFlag = false
          // }
        })
    }
  },
  mounted () {
    // console.log(this.$route.query)
    this.params.orderSource = this.$route.query.orderSource
    this.params.addressId = this.$route.query.addressId
    if (this.params.orderSource === '10') {
      // 购物车下单
      let numberList = this.$route.query.goodsNum.split(',')
      let goodsskuIdList = this.$route.query.goodsskuId.split(',')
      let goodsspuIdList = this.$route.query.goodsspuId.split(',')
      numberList.forEach((item, index) => {
        this.params.shoppingCartFormList.push({
          goodsNum: item,
          goodsSkuId: goodsskuIdList[index],
          goodsSpuId: goodsspuIdList[index]
        })
      })
    } else if (this.params.orderSource === '20') {
      // 立即下单
      this.params.shoppingCart = {
        goodsNum: this.$route.query.goodsNum,
        goodsSkuId: this.$route.query.goodsskuId,
        goodsSpuId: this.$route.query.goodsspuId
      }
    }
    this.getOrder()
    // this.getInvoiceInfo()
    // this.getAddressInfo()
    this.getUserInfo()
  }
}
</script>

<style lang='scss' scoped>
</style>
